export default "__VITE_PUBLIC_ASSET__fef2a683__"